var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.003,
    height: 52.984,
    viewBox: "0 0 53.003 52.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;stroke:#ff6a08;stroke-width:2px;}.b{clip-path:url(#a);}.c{stroke-linecap:round;stroke-linejoin:round;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 53.003,
    height: 52.984
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "c",
    y1: 18.101,
    transform: "translate(45.06 33.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M25.2,4.731c0,1.663-1.322,3.982-2.952,3.982S19.3,6.394,19.3,4.731a2.953,2.953,0,1,1,5.9,0Z",
    transform: "translate(22.812 2.035)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M33.77,44.151l1.167-21.4c.015-.43,1.379.131,1.394-.279.554-15.137-.681-16.1-.82-16.22C35.347,6.2,34,6.165,33.6,6.138a1.349,1.349,0,0,0-1.266.8,2.812,2.812,0,0,1-4.764,0,1.349,1.349,0,0,0-1.266-.8c-.343.022-9.7,1.56-12.643,2.058a1.077,1.077,0,0,0,.079,2.128l11.225,1.047V22.746l1.167,21.4",
    transform: "translate(15.112 7.252)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    y1: 2.141,
    transform: "translate(21.057 1.418)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    y1: 2.141,
    transform: "translate(34.15 1.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M34.473,38.727H.65V1.631h36",
    transform: "translate(0.768 1.928)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5.26,13.373a2.134,2.134,0,1,1,2.134-2.134A2.135,2.135,0,0,1,5.26,13.373Z",
    transform: "translate(3.695 10.762)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2.134,
    cy: 2.134,
    r: 2.134,
    transform: "translate(17.762 12.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M14.417,17.731A2.134,2.134,0,1,1,16.551,15.6,2.138,2.138,0,0,1,14.417,17.731Z",
    transform: "translate(14.517 15.914)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 7.009,
    y2: 5.207,
    transform: "translate(10.753 15.651)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 6.725,
    y2: 13.479,
    transform: "translate(21.053 16.243)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    y2: 6.271,
    transform: "translate(27.604 45.294)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 13.093,
    transform: "translate(19.966 51.565)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoard);
export default __webpack_public_path__ + "static/media/board.456115fd.svg";
export { ForwardRef as ReactComponent };